// @hooks
import useSWR from "swr";

// @utils
import { chartApiUrl, fetcher } from "@/utils";

const endpoint = `${process.env.NEXT_PUBLIC_API_URL_V1}/adoption`;

export function useAdoptionSinceLaunch(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/since-launch`, variation) : null,
    fetcher,
  );
}

export function useNewHolders(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/new-holders`, variation) : null,
    fetcher,
  );
}

export function useNewStakers(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/new-stakers`, variation) : null,
    fetcher,
  );
}

export function useHexHolders(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/hex-holders-by-amount`, variation)
      : null,
    fetcher,
  );
}

export function useHexHoldersByUsd(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch
      ? chartApiUrl(`${endpoint}/hex-holders-by-usd-amount`, variation)
      : null,
    fetcher,
  );
}
